module.exports = __webpack_public_path__ + "static/media/mv_attention.e6935249.jpg";